import type { OfferConfig } from "@/types/offer";

export const sopCoverageOffer: OfferConfig = {
  offerId: "sop-coverage",
  pipeline: "sop-coverage",
  title: "Regulatory gap analysis",
  subtitle:
    "Upload one regulation and your SOPs. We assess every obligation against your procedures and show the gaps, with evidence.",
  intro:
    "Upload your regulation first, then your SOP documents. We assess coverage obligation by obligation and email you a free preview, usually under 30 minutes (larger document sets can take longer). Pay only to upgrade to the full report (Word report + Excel register).",
  estimatedMinutes: 3,
  pricing: {
    fromPriceLabel: "Free preview on your own document · Full analysis from €597 excl. VAT",
    priceRangeLabel: "Final quote shown on your preview, based on document size",
    currency: "eur",
  },
  steps: [
    {
      id: "intro",
      type: "statement",
      title: "Regulation vs SOP coverage analysis",
      description:
        "Upload the regulation or standard first, then one or more SOP/procedure documents to compare against it. We score every obligation, show the SOP evidence behind each finding, and produce a reviewer-ready Word report and Excel register.",
      ctaLabel: "Get started",
    },
    {
      id: "context",
      type: "textarea",
      title: "Anything we should know?",
      description: "Optional. A sentence of context helps tailor the analysis.",
      placeholder: "e.g. Compare our QMS SOPs against ISO 13485 requirements.",
      required: false,
      rows: 4,
      validation: { maxLength: 2000 },
    },
    {
      id: "files",
      type: "fileUpload",
      title: "Upload your documents",
      description:
        "Order matters. PDF, Word, or Excel up to 10 MB each (2 to 11 files).",
      required: true,
      minFiles: 2,
      maxFiles: 11,
      allowedFileTypes: [".pdf", ".docx", ".xlsx"],
      maxFileSizeMb: 10,
      helpText:
        "First file = regulation/primary. Remaining files = SOPs to compare. Up to ~165 pages per document.",
      orderedUploadHint: {
        title: "Upload order matters",
        items: [
          "First file: the regulation or standard (what you are measured against)",
          "Remaining files: your SOPs / procedures to compare against it",
        ],
      },
    },
    {
      id: "email",
      type: "email",
      title: "Where should we send your preview?",
      description: "We'll email your preview when analysis is complete.",
      placeholder: "you@company.com",
      required: true,
    },
    {
      id: "review",
      type: "review",
      title: "Review and submit",
      submitLabel: "Submit for analysis",
    },
  ],
};
